import State from '../interfaces/states/State';

import * as moment from 'moment';

export const dateStart$ = (state: State): moment.Moment | number => state.datepickers.dateStart;

export const dateEnd$ = (state: State): moment.Moment | number => state.datepickers.dateEnd;
